// import { mapGetters } from "vuex";
// import { mapGetters } from "vuex";

export default {
  data() {
    return {
      // eslint-disable-next-line
      // eslint-disable-next-line
      resourcesQAOptions: [
        "Standard",
        "Certificate",
        "Review"
      ],
      // eslint-disable-next-line
      resourcesDeliveryOrginOptions: [
        "Local",
        "State",
        "National",
        "Overseas"
      ],
      // eslint-disable-next-line
      resourcesSourceOptions: [
        "Reuse",
        "Site",
        "Workshop",
        "Warehouse",
        "External"
      ],
      // eslint-disable-next-line
      limitsTypeOptions: [
        "Time",
        "PerHr",
        "Cost",
        "Carbon"
      ],
      // eslint-disable-next-line
      limitsImpactOptions: [
        "Safety",
        "Ops",
        "Business"
      ],
      // eslint-disable-next-line
      resourcesStatusOptions: [
        "Ready",
        "Issue"
      ],
      // eslint-disable-next-line
      resourcesUnitsOptions: [
        "Reuse",
        "Site",
        "Workshop",
        "Warehouse",
        "Order"
      ]
    };
  }
};
